import React from "react";
import parentClasses from "../Buttons.module.scss";
import { BTN_TYPE_SECONDARY_LIGHT } from "../../../constants/buttons";
import * as routes from "../../../constants/routes";
import * as btnConfig from "../btnsSetup";
import { useNavigate } from "react-router-dom";

const ButtonBePremium = ({
  className = "",
  rounded = null,
  size = null,
  alt = null,
  btnType = BTN_TYPE_SECONDARY_LIGHT,
  title = null,
  style = {},
  text = "Assinar",
}) => {
  const navigate = useNavigate();
  const btnRoundedClass = rounded ? parentClasses.Rounded : "";
  const _text = <span className={parentClasses.Text}>{text}</span>;

  let btnTypeClass = btnConfig.getBtnTypeClass(btnType);

  // Check the button size
  let btnSizeClass = btnConfig.getBtnSize(size);

  alt = alt ? alt : title ? title : text;
  const onClickedControl = () => {
    navigate(routes.R_BUY);
  };
  /**
   * Returing button
   */
  return (
    <a
      style={style}
      className={`${btnTypeClass} ${btnSizeClass} ${btnRoundedClass}  ${className}`}
      title={title ? title : null}
      alt={alt}
      onClick={() => {
        onClickedControl();
      }}
    >
      {_text}
    </a>
  );
};

export default ButtonBePremium;
